/** Clears location visibility on server (e.g. logout). */
export class RemoveLocationAccessAction {
  static readonly type = '[UserLocationAccess] RemoveLocationAccessAction';
}
